export interface WindowDimensions {
  width: number;
  height: number;
}

export default function getWindowDimensions(): WindowDimensions {
  if (typeof window === 'undefined') return {width: 1920, height: 1080};
  return {width: window.innerWidth, height: window.innerHeight};
}
